<ul class="navbar-nav ml-auto">
  <li>
    <i class="icon feather icon-user"></i><span class="small ml-2"> {{ (userInfo$ | async)?.nombre_usuario }}</span>
  </li>
  <li>
    <div class="pro-head" (click)="cerrarSesion()" style="cursor: pointer;">
      <span class="small mr-2">Cerrar sesión</span>
      <a href="javascript:" class="dud-logout" title="Logout" ><i class="feather icon-log-out"></i></a>
    </div>
  </li>
  <!-- <li *ngIf="usuario">
    <div class="dropdown drp-user" ngbDropdown placement="auto">
      <a href="javascript:" ngbDropdownToggle data-toggle="dropdown">
        <i class="icon feather icon-user"></i><span class="small"> {{ usuario }}</span>
      </a>
      <div class="dropdown-menu dropdown-menu-right profile-notification" ngbDropdownMenu>
        <div class="pro-head" (click)="cerrarSesion()" style="cursor: pointer;">
          <span class="small">Cerrar sesión</span>
          <a href="javascript:" class="dud-logout" title="Logout" ><i class="feather icon-log-out"></i></a>
        </div>
      </div>
    </div>
  </li> -->
</ul>
